module.exports = __webpack_public_path__ + "img/red-2-squiggly-open.0fcc8134.svg";